<template>
  <div id="InventoryCheckMgmt" class="purchase-mgmt-page inventory-check-mgmt-page">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>采购管理</el-breadcrumb-item>
        <el-breadcrumb-item>盘库管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div ref="header" class="page-header">
      <div class="filter-card header-box">
        <div class="filter-row">
          <div class="filter-item">
            <span class="filter-label">盘库日期</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              size="small"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
              class="filter-date"
            ></el-date-picker>
          </div>
          <div class="filter-item">
            <span class="filter-label">产品类型</span>
            <el-select class="filter-select-wide" placeholder="全部" size="small" v-model="params.productType" filterable clearable>
              <el-option label="全部" value=""></el-option>
              <el-option v-for="product in productList" :key="product.type" :label="product.productName" :value="product.productType"></el-option>
            </el-select>
          </div>
        </div>
        <div class="filter-toolbar">
          <div class="filter-actions">
            <el-button type="primary" size="small" icon="el-icon-search" @click="onSearch">查询</el-button>
            <el-button type="primary" size="small" class="toolbar-action-btn" @click="openCreateCheck">新增盘库计划</el-button>
            <el-button type="primary" size="small" class="toolbar-action-btn" @click="openManualAdjust">新增库存调整</el-button>
            <el-button size="small" class="toolbar-action-btn" @click="showAdjustOpreateLogs">
              库存调整记录
            </el-button>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeStatusTab" class="status-tabs" @tab-click="onStatusTabChange">
        <el-tab-pane v-for="tab in statusTabs" :key="tab.name" :name="tab.name">
          <span slot="label">
            {{ tab.label }}
            <el-badge v-if="tab.showBadge && statusCounts[tab.name] > 0" :value="statusCounts[tab.name]" class="status-tab-badge"></el-badge>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="table-panel" ref="tablePanel">
      <div class="table-container">
        <el-table
          ref="table"
          :data="tableData"
          border
          stripe
          size="mini"
          :height="screenHeight"
          v-loading="loading"
          element-loading-text="加载中..."
          header-cell-class-name="table-header-cell"
          class="mgmt-table"
        >
          <el-table-column label="序号" width="55" align="center">
            <template slot-scope="scope">{{ (currentPage - 1) * params.pageSize + scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column prop="planDate" label="计划盘库日期" width="120" align="center"></el-table-column>
          <el-table-column prop="statusLabel" label="状态" width="120" align="center"></el-table-column>
          <el-table-column label="店铺" width="90" align="center">
            <template slot-scope="scope">
              <div v-if="getRowScopes(scope.row).length" class="scope-lines">
                <div v-for="(item, idx) in getRowScopes(scope.row)" :key="'shop-' + idx" class="scope-line" style="text-align: center;">
                  {{ formatScopeShopName(item) }}
                </div>
              </div>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="产品类型" min-width="140">
            <template slot-scope="scope">
              <div v-if="getRowScopes(scope.row).length" class="scope-lines">
                <div v-for="(item, idx) in getRowScopes(scope.row)" :key="'pt-' + idx" class="scope-line">
                  {{ formatScopeProductName(item) }}
                </div>
              </div>
              <span v-else>{{ scope.row.productTypeSummary || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="采购颜色" min-width="160">
            <template slot-scope="scope">
              <div v-if="getRowScopes(scope.row).length" class="scope-lines">
                <div v-for="(item, idx) in getRowScopes(scope.row)" :key="'pc-' + idx" class="scope-line">
                  {{ formatScopePurchaseColor(item) }}
                </div>
              </div>
              <span v-else>{{ scope.row.purchaseColorSummary || "-" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="160" align="center">
            <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="420" align="left" fixed="right" class-name="action-col">
            <template slot-scope="scope">
              <el-button
                v-if="canStart(scope.row)"
                type="text"
                size="mini"
                class="action-btn success"
                :loading="startingId === scope.row.id"
                @click="onStart(scope.row)"
              >
                开始盘库
              </el-button>
              <el-button
                v-if="canSubmit(scope.row)"
                type="text"
                size="mini"
                class="action-btn success"
                @click="openSubmit(scope.row)"
              >
                确认盘库
              </el-button>
              <el-button
                v-if="canConfirmDiff(scope.row)"
                type="text"
                size="mini"
                class="action-btn success"
                @click="openReview(scope.row)"
              >
                确认偏差
              </el-button>
              <el-button
                v-if="canReject(scope.row)"
                type="text"
                size="mini"
                class="action-btn warning"
                :loading="rejectingId === scope.row.id"
                @click="onReject(scope.row)"
              >
                打回
              </el-button>
              <el-button
                v-if="canViewSnapshot(scope.row)"
                type="text"
                size="mini"
                class="action-btn"
                @click="openSnapshot(scope.row)"
              >
                查看库存快照
              </el-button>
              <el-button
                v-if="canViewAdjust(scope.row)"
                type="text"
                size="mini"
                class="action-btn"
                @click="openAdjust(scope.row)"
              >
                查看库存调整
              </el-button>
              <el-button
                v-if="canEditRemark(scope.row)"
                type="text"
                size="mini"
                class="action-btn"
                @click="onEditRemark(scope.row)"
              >
                编辑备注
              </el-button>
              <el-button
                v-if="canVoid(scope.row)"
                type="text"
                size="mini"
                class="action-btn danger"
                @click="onVoid(scope.row)"
              >
                作废
              </el-button>
              <el-button type="text" size="mini" class="action-btn" @click="showOpreateLog(scope.row)">操作记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next"
          background
          prev-text="上一页"
          next-text="下一页"
          :current-page.sync="currentPage"
          :page-size="params.pageSize"
          :total="total"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="编辑备注" :visible.sync="remarkDialogVisible" width="520px" append-to-body :close-on-click-modal="false">
      <el-input
        type="textarea"
        :rows="4"
        maxlength="500"
        show-word-limit
        v-model="remarkForm.remark"
        placeholder="请输入备注"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="remarkDialogVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="remarkSubmitting" @click="submitRemark">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="opreateLogTitle" :visible.sync="opreateLogVisible" width="1000px" append-to-body>
      <el-table
        :key="opreateLogMode"
        :data="operateHistory"
        border
        stripe
        size="mini"
        max-height="420"
        v-loading="opreateLogLoading"
      >
        <el-table-column label="序号" width="55" align="center">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="opreateTime" label="操作时间" width="160" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.opreateTime) }}</template>
        </el-table-column>
        <el-table-column
          v-if="opreateLogMode === 'adjust'"
          prop="opreateTypeLabel"
          label="操作类型"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="opreateLogMode === 'adjust'"
          prop="content"
          label="内容"
          min-width="280"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          v-if="opreateLogMode === 'adjust'"
          prop="opreateUserName"
          label="操作人"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column v-if="opreateLogMode === 'adjust'" label="操作" width="260" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="canViewAdjustFromLog(scope.row)"
              type="text"
              size="mini"
              class="action-btn"
              @click="viewAdjustFromLog(scope.row)"
            >
              查看库存调整
            </el-button>
            <el-button
              v-if="canVoidAdjustFromLog(scope.row)"
              type="text"
              size="mini"
              class="action-btn danger"
              :loading="voidingAdjustKey === getAdjustLogKey(scope.row)"
              @click="onVoidAdjustFromLog(scope.row)"
            >
              作废
            </el-button>
            <el-button
              type="text"
              size="mini"
              class="action-btn danger"
              :loading="deletingAdjustLogKey === getAdjustLogKey(scope.row)"
              @click="onDeleteAdjustLog(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-if="opreateLogMode !== 'adjust'"
          prop="opreateUserName"
          label="操作人"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="opreateLogMode !== 'adjust'"
          prop="opreateTypeLabel"
          label="操作类型"
          width="120"
        ></el-table-column>
        <el-table-column
          v-if="opreateLogMode !== 'adjust'"
          prop="bussinessId"
          label="业务ID"
          width="160"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          v-if="opreateLogMode !== 'adjust'"
          prop="content"
          label="内容"
          min-width="280"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="opreateLogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <inventory-check-snapshot-dialog ref="snapshotDialog"></inventory-check-snapshot-dialog>
    <inventory-check-adjust-dialog ref="adjustDialog"></inventory-check-adjust-dialog>
    <submit-inventory-check-dialog ref="submitDialog" @success="getData"></submit-inventory-check-dialog>
    <create-inventory-check-dialog ref="createCheckDialog" @success="onCreateSuccess"></create-inventory-check-dialog>
    <create-manual-inventory-adjust-dialog
      ref="manualAdjustDialog"
      @success="onManualAdjustSuccess"
    ></create-manual-inventory-adjust-dialog>
  </div>
</template>

<script>
import request from "../../request/requestModules.js";
import { activeProducts, allActiveProducts } from "../../utils/constant.js";
import {
  INVENTORY_CHECK_STATUS,
  INVENTORY_CHECK_STATUS_TABS,
  canStartInventoryCheck,
  canViewInventoryCheckSnapshot,
  canViewInventoryCheckAdjust,
  canSubmitInventoryCheck,
  canConfirmInventoryCheckDiff,
  canRejectInventoryCheckDiff,
  canVoidInventoryCheck,
  canEditInventoryCheckRemark,
  getInventoryCheckStatusLabel,
} from "./inventoryCheckStatus.js";
import InventoryCheckSnapshotDialog from "./InventoryCheckSnapshotDialog.vue";
import InventoryCheckAdjustDialog from "./InventoryCheckAdjustDialog.vue";
import SubmitInventoryCheckDialog from "./SubmitInventoryCheckDialog.vue";
import CreateInventoryCheckDialog from "./CreateInventoryCheckDialog.vue";
import CreateManualInventoryAdjustDialog from "./CreateManualInventoryAdjustDialog.vue";

export default {
  name: "InventoryCheckMgmt",
  components: {
    InventoryCheckSnapshotDialog,
    InventoryCheckAdjustDialog,
    SubmitInventoryCheckDialog,
    CreateInventoryCheckDialog,
    CreateManualInventoryAdjustDialog,
  },
  data() {
    return {
      productList: localStorage.getItem("shopType") == 6 ? allActiveProducts : activeProducts,
      statusTabs: INVENTORY_CHECK_STATUS_TABS,
      activeStatusTab: String(INVENTORY_CHECK_STATUS.PENDING),
      statusCounts: {},
      dateRange: [],
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      screenHeight: 500,
      params: {
        productType: "",
        status: "",
        beginIndex: 0,
        pageSize: 50,
      },
      remarkDialogVisible: false,
      remarkSubmitting: false,
      remarkForm: {
        id: "",
        remark: "",
      },
      opreateLogVisible: false,
      opreateLogLoading: false,
      opreateLogTitle: "操作记录",
      opreateLogMode: "plan", // plan | adjust
      operateHistory: [],
      startingId: "",
      rejectingId: "",
      voidingAdjustKey: "",
      deletingAdjustLogKey: "",
    };
  },
  mounted() {
    this.relayoutTable();
    window.addEventListener("resize", this.relayoutTable);
    this.getData();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.relayoutTable);
  },
  methods: {
    calcTableHeight() {
      const panel = this.$refs.tablePanel;
      if (!panel) return;
      const pagination = panel.querySelector(".pagination-box");
      const panelStyle = window.getComputedStyle(panel);
      const paddingTop = parseFloat(panelStyle.paddingTop) || 0;
      const paddingBottom = parseFloat(panelStyle.paddingBottom) || 0;
      const available =
        panel.clientHeight - paddingTop - paddingBottom - (pagination ? pagination.offsetHeight : 0);
      this.screenHeight = Math.max(available, 200);
    },
    relayoutTable() {
      this.$nextTick(() => {
        this.calcTableHeight();
        this.$nextTick(() => {
          if (this.$refs.table && this.$refs.table.doLayout) {
            this.$refs.table.doLayout();
          }
        });
      });
    },
    formatTime(ts) {
      if (!ts) return "";
      const d = new Date(Number(ts));
      if (Number.isNaN(d.getTime())) return "";
      const pad = n => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    getRowScopes(row) {
      return (row && Array.isArray(row.scopes) ? row.scopes : []).filter(Boolean);
    },
    formatScopeShopName(scope) {
      const productType = scope && scope.productType;
      const product = (this.productList || []).find(item => ~~item.productType === ~~productType);
      return String((product && product.shopName) || "").trim() || "-";
    },
    formatScopeProductName(scope) {
      const productType = scope && scope.productType;
      const product = (this.productList || []).find(item => ~~item.productType === ~~productType);
      return (
        String((scope && scope.productName) || "").trim() ||
        String((product && (product.productName || product.name)) || "").trim() ||
        (productType ? `类型${productType}` : "-")
      );
    },
    formatScopePurchaseColor(scope) {
      if (!scope) return "-";
      if (scope.colorMode === "all") return "全部";
      const names = (scope.purchaseColorNames || []).map(n => String(n || "").trim()).filter(Boolean);
      return names.length ? names.join("、") : "-";
    },
    canStart(row) {
      return canStartInventoryCheck(row && row.status);
    },
    canViewSnapshot(row) {
      return canViewInventoryCheckSnapshot(row && row.status);
    },
    canViewAdjust(row) {
      return canViewInventoryCheckAdjust(row && row.status);
    },
    canSubmit(row) {
      return canSubmitInventoryCheck(row && row.status);
    },
    canConfirmDiff(row) {
      return canConfirmInventoryCheckDiff(row && row.status);
    },
    canReject(row) {
      return canRejectInventoryCheckDiff(row && row.status);
    },
    canVoid(row) {
      return canVoidInventoryCheck(row && row.status);
    },
    canEditRemark(row) {
      return canEditInventoryCheckRemark(row && row.status);
    },
    onSearch() {
      this.currentPage = 1;
      this.getData();
    },
    onStatusTabChange() {
      this.currentPage = 1;
      this.getData();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getData();
    },
    buildQuery() {
      const params = {
        beginIndex: (this.currentPage - 1) * this.params.pageSize,
        pageSize: this.params.pageSize,
      };
      if (this.params.productType !== "" && this.params.productType != null) {
        params.productType = this.params.productType;
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.beginDate = this.dateRange[0];
        params.endDate = this.dateRange[1];
      }
      if (this.activeStatusTab && this.activeStatusTab !== "all") {
        params.status = this.activeStatusTab;
      }
      return params;
    },
    normalizeStatusCounts(raw) {
      const counts = {};
      const source = raw || {};
      Object.keys(source).forEach(key => {
        counts[String(key)] = Number(source[key]) || 0;
      });
      return counts;
    },
    getData() {
      this.loading = true;
      request
        .fetchInventoryChecks(this.buildQuery())
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "获取盘库计划失败");
            this.tableData = [];
            this.total = 0;
            return;
          }
          this.tableData = (res.ldata || []).map(row => ({
            ...row,
            id: row.id || (row._id ? String(row._id) : ""),
            statusLabel: row.statusLabel || getInventoryCheckStatusLabel(row.status),
          }));
          this.total = res.total || 0;
          this.statusCounts = this.normalizeStatusCounts(res.mdata && res.mdata.statusCounts);
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取盘库计划失败");
        })
        .finally(() => {
          this.loading = false;
          this.relayoutTable();
        });
    },
    openCreateCheck() {
      this.$refs.createCheckDialog && this.$refs.createCheckDialog.open();
    },
    onCreateSuccess() {
      this.activeStatusTab = String(INVENTORY_CHECK_STATUS.PENDING);
      this.currentPage = 1;
      this.getData();
    },
    openManualAdjust() {
      this.$refs.manualAdjustDialog && this.$refs.manualAdjustDialog.open();
    },
    onManualAdjustSuccess(mdata) {
      const id = mdata && mdata.id ? String(mdata.id) : "";
      if (!id) return;
      this.$confirm("库存调整已提交。是否查看库存调整记录？", "提示", {
        confirmButtonText: "查看",
        cancelButtonText: "关闭",
        type: "success",
      })
        .then(() => {
          this.showAdjustOpreateLogs();
        })
        .catch(() => {});
    },
    openSnapshot(row) {
      if (!this.canViewSnapshot(row)) {
        this.$message.warning("请先开始盘库后再查看库存快照");
        return;
      }
      this.$refs.snapshotDialog && this.$refs.snapshotDialog.open(row);
    },
    openAdjust(row) {
      if (!this.canViewAdjust(row)) {
        this.$message.warning("仅已盘库可查看库存调整");
        return;
      }
      this.$refs.adjustDialog && this.$refs.adjustDialog.open(row);
    },
    canViewAdjustFromLog(row) {
      const label = String((row && row.opreateTypeLabel) || "");
      const content = String((row && row.content) || "");
      return label.indexOf("新增库存调整") >= 0 || content.indexOf("生成调整单") >= 0 || content.indexOf("新增库存调整") >= 0;
    },
    getAdjustLogKey(row) {
      return String((row && (row._id || row.bussinessId)) || "") + "-" + String((row && row.opreateTime) || "");
    },
    extractAdjustPlanId(row) {
      const content = String((row && row.content) || "");
      const matched = content.match(/(?:新增库存调整|生成调整单|作废库存调整)「([^」]+)」/);
      return matched && matched[1] ? matched[1] : "";
    },
    getVoidedAdjustPlanIds() {
      const ids = {};
      (this.operateHistory || []).forEach(item => {
        if (String((item && item.opreateTypeLabel) || "").indexOf("作废库存调整") < 0) return;
        const planId = this.extractAdjustPlanId(item);
        if (planId) ids[planId] = true;
      });
      return ids;
    },
    canVoidAdjustFromLog(row) {
      if (!this.canViewAdjustFromLog(row)) return false;
      const planId = this.extractAdjustPlanId(row);
      if (planId && this.getVoidedAdjustPlanIds()[planId]) return false;
      return true;
    },
    onVoidAdjustFromLog(row) {
      if (!this.canVoidAdjustFromLog(row)) {
        this.$message.warning("该库存调整不可作废");
        return;
      }
      if (this.voidingAdjustKey) return;
      const planId = this.extractAdjustPlanId(row);
      const label = String((row && row.opreateTypeLabel) || "");
      const isManual = label.indexOf("新增库存调整") >= 0;
      const payload = isManual
        ? { id: String((row && row.bussinessId) || "").trim() }
        : { inventoryCheckId: String((row && row.bussinessId) || "").trim() };
      if (!payload.id && !payload.inventoryCheckId) {
        this.$message.warning("缺少业务ID");
        return;
      }
      this.$confirm(`确认作废库存调整「${planId || ""}」？`, "作废", {
        confirmButtonText: "确定作废",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.voidingAdjustKey = this.getAdjustLogKey(row);
          return request.voidInventoryAdjust(payload);
        })
        .then(res => {
          if (!res) return;
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "作废失败");
            return;
          }
          this.$message.success("作废成功");
          this.showAdjustOpreateLogs();
        })
        .catch(err => {
          if (err === "cancel" || err === "close") return;
          this.$message.error((err && err.message) || "作废失败");
        })
        .finally(() => {
          this.voidingAdjustKey = "";
        });
    },
    onDeleteAdjustLog(row) {
      const id = row && row._id ? String(row._id) : "";
      if (!id) {
        this.$message.warning("缺少记录ID");
        return;
      }
      if (this.deletingAdjustLogKey) return;
      this.$confirm("确认删除该条库存调整记录？", "删除", {
        confirmButtonText: "确定删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deletingAdjustLogKey = this.getAdjustLogKey(row);
          return request.deleteInventoryAdjustOpreateLog({ _id: id });
        })
        .then(res => {
          if (!res) return;
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "删除失败");
            return;
          }
          this.$message.success("删除成功");
          this.showAdjustOpreateLogs();
        })
        .catch(err => {
          if (err === "cancel" || err === "close") return;
          this.$message.error((err && err.message) || "删除失败");
        })
        .finally(() => {
          this.deletingAdjustLogKey = "";
        });
    },
    viewAdjustFromLog(row) {
      const id = String((row && row.bussinessId) || "").trim();
      if (!id) {
        this.$message.warning("缺少业务ID");
        return;
      }
      const label = String((row && row.opreateTypeLabel) || "");
      if (label.indexOf("新增库存调整") >= 0) {
        this.$refs.adjustDialog && this.$refs.adjustDialog.openByAdjustId(id);
        return;
      }
      this.$refs.adjustDialog && this.$refs.adjustDialog.open({ id });
    },
    openSubmit(row) {
      this.$refs.submitDialog && this.$refs.submitDialog.open(row, "submit");
    },
    openReview(row) {
      this.$refs.submitDialog && this.$refs.submitDialog.open(row, "review");
    },
    onReject(row) {
      if (!this.canReject(row)) {
        this.$message.warning("仅待确认库存偏差可打回");
        return;
      }
      if (this.rejectingId) return;
      this.$confirm(`确认打回盘库「${row.planId || ""}」至盘库中，可重新修改盘库数量？`, "打回", {
        confirmButtonText: "确定打回",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.rejectingId = row.id;
          return request.rejectInventoryCheckDiff({ id: row.id });
        })
        .then(res => {
          if (!res) return;
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "打回失败");
            return;
          }
          this.$message.success("已打回盘库中");
          this.activeStatusTab = String(INVENTORY_CHECK_STATUS.IN_PROGRESS);
          this.currentPage = 1;
          this.getData();
        })
        .catch(err => {
          if (err === "cancel" || (err && err === "close")) return;
          this.$message.error((err && err.message) || "打回失败");
        })
        .finally(() => {
          this.rejectingId = "";
        });
    },
    onStart(row) {
      if (!this.canStart(row)) {
        this.$message.warning("仅待盘库可开始盘库");
        return;
      }
      if (this.startingId) return;
      this.$confirm(`确认开始盘库「${row.planId || ""}」？将先更新本地库存，再生成库存快照。`, "开始盘库", {
        confirmButtonText: "开始盘库",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.startingId = row.id;
          return request.startInventoryCheck({ id: row.id });
        })
        .then(res => {
          if (!res) return;
          if (res.result != 1 && res.code != 0) {
            this.$alert(res.message || "开始盘库失败", "无法开始盘库", {
              type: "error",
              confirmButtonText: "知道了",
            });
            return;
          }
          const lineCount = (res.mdata && res.mdata.lineCount) || 0;
          this.$message.success(lineCount ? `已开始盘库，快照 ${lineCount} 行` : "已开始盘库");
          this.activeStatusTab = String(INVENTORY_CHECK_STATUS.IN_PROGRESS);
          this.currentPage = 1;
          this.getData();
        })
        .catch(err => {
          if (err === "cancel" || (err && err === "close")) return;
          this.$alert((err && err.message) || "开始盘库失败", "无法开始盘库", {
            type: "error",
            confirmButtonText: "知道了",
          });
        })
        .finally(() => {
          this.startingId = "";
        });
    },
    onVoid(row) {
      if (!this.canVoid(row)) {
        this.$message.warning("当前状态不可作废");
        return;
      }
      this.$confirm(`确认作废盘库计划「${row.planId || ""}」？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return request.voidInventoryCheck({ id: row.id });
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "作废失败");
            return;
          }
          this.$message.success("作废成功");
          this.getData();
        })
        .catch(err => {
          if (err === "cancel" || (err && err === "close")) return;
          this.$message.error((err && err.message) || "作废失败");
        });
    },
    onEditRemark(row) {
      if (!this.canEditRemark(row)) {
        this.$message.warning("当前状态不可编辑备注");
        return;
      }
      this.remarkForm = {
        id: row.id,
        remark: row.remark || "",
      };
      this.remarkDialogVisible = true;
    },
    submitRemark() {
      if (this.remarkSubmitting) return;
      if (!this.remarkForm.id) return;
      this.remarkSubmitting = true;
      request
        .updateInventoryCheckRemark({
          id: this.remarkForm.id,
          remark: this.remarkForm.remark,
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "编辑备注失败");
            return;
          }
          this.$message.success("备注已保存");
          this.remarkDialogVisible = false;
          this.getData();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "编辑备注失败");
        })
        .finally(() => {
          this.remarkSubmitting = false;
        });
    },
    showOpreateLog(row, title) {
      const id = row && (row.id || (row._id ? String(row._id) : ""));
      if (!id) {
        this.$message.warning("缺少业务ID");
        return;
      }
      this.opreateLogMode = "plan";
      this.opreateLogTitle = title || "盘库计划操作记录";
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      request
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          bussinessId: id,
          beginIndex: 0,
          pageSize: 1000,
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "获取操作记录失败");
            this.operateHistory = [];
            return;
          }
          const list = res.ldata || [];
          list.sort((a, b) => (Number(b.opreateTime) || 0) - (Number(a.opreateTime) || 0));
          this.operateHistory = list;
          if (!list.length) {
            this.$message.info("暂无操作记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
    showAdjustOpreateLogs() {
      this.opreateLogMode = "adjust";
      this.opreateLogTitle = "库存调整记录";
      this.operateHistory = [];
      this.opreateLogVisible = true;
      this.opreateLogLoading = true;
      request
        .fetchOpreateLogs({
          startTime: 0,
          endTime: new Date().getTime(),
          opreateType: 12,
          beginIndex: 0,
          pageSize: 200,
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "获取操作记录失败");
            this.operateHistory = [];
            return;
          }
          const list = (res.ldata || []).filter(item => {
            const label = String((item && item.opreateTypeLabel) || "");
            const content = String((item && item.content) || "");
            return label.indexOf("库存调整") >= 0 || content.indexOf("新增库存调整") >= 0 || content.indexOf("生成调整单") >= 0;
          });
          list.sort((a, b) => (Number(b.opreateTime) || 0) - (Number(a.opreateTime) || 0));
          this.operateHistory = list;
          if (!list.length) {
            this.$message.info("暂无库存调整记录");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取操作记录失败");
        })
        .finally(() => {
          this.opreateLogLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/purchaseMgmtPage.scss";

#InventoryCheckMgmt.inventory-check-mgmt-page {
  .breadcrumb-box {
    flex-shrink: 0;
    margin: 0 0 12px;
    padding: 10px 16px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    border: 1px solid #ebeef5;

    .el-breadcrumb {
      line-height: 22px;
      font-size: 13px;
    }

    .el-breadcrumb__inner {
      line-height: 22px;
    }
  }

  .filter-toolbar {
    margin-top: 4px;
    padding-top: 10px;
    border-top: 1px dashed #ebeef5;
  }

  /* 覆盖全局 common.scss：.header-box .el-button { width: 80px } 导致长文案截断 */
  .header-box .filter-actions .el-button,
  .filter-actions .el-button {
    width: auto !important;
    min-width: auto !important;
    height: auto !important;
    min-height: 32px;
    padding: 7px 15px !important;
    line-height: 1.3 !important;
    white-space: nowrap !important;
    overflow: visible !important;
    letter-spacing: 0;
    vertical-align: middle;
    box-sizing: border-box;
    margin: 0;

    > span {
      display: inline-flex;
      align-items: center;
      white-space: nowrap !important;
      line-height: 1.3;
      overflow: visible;
    }
  }

  .filter-actions {
    .toolbar-action-btn {
      min-width: 120px !important;
    }

    .toolbar-action-btn-wide {
      min-width: 148px !important;
    }
  }

  .mgmt-table {
    .scope-lines {
      line-height: 1.5;
      text-align: left;
    }

    .scope-line {
      padding: 1px 0;
      word-break: break-all;
    }

    .scope-line + .scope-line {
      border-top: 1px dashed #ebeef5;
      margin-top: 2px;
      padding-top: 3px;
    }

    .el-table__fixed-right .cell,
    td .cell {
      overflow: visible;
      text-overflow: clip;
      white-space: normal;
      line-height: 1.4;
      padding-top: 6px;
      padding-bottom: 6px;
    }

    .el-button--text {
      padding: 2px 6px;
      margin: 0 2px;
      height: auto;
      line-height: 1.4;
      white-space: nowrap !important;
      overflow: visible !important;
      letter-spacing: 0;

      > span {
        display: inline-block;
        white-space: nowrap !important;
        line-height: 1.4;
        overflow: visible;
      }

      &.action-btn.success {
        color: #67c23a;
      }

      &.action-btn.warning {
        color: #e6a23c;
      }

      &.action-btn.danger {
        color: #f56c6c;
      }
    }
  }
}
</style>
